import { useState, useEffect } from "react";
import { Col, Row, Alert } from "react-bootstrap";

export const Newsletter = ({ status, message, onValidated }) => {
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (status === "success") clearFields();
  }, [status]);

  const handleSubmit = (e) => {
    e.preventDefault();
    email &&
      email.indexOf("@") > -1 &&
      onValidated({
        EMAIL: email,
      });
  };

  const clearFields = () => {
    setEmail("");
  };

  return (
    <Col lg={12}>
      <div className='newsletter-bx wow slideInUp'>
        <Row>
          <h3>
            Interested in working together?<br></br> We should queue up a chat.
            I’ll buy the coffee.
          </h3>
          <Col lg={12} md={6} xl={5}></Col>
        </Row>
      </div>
    </Col>
  );
};
